import TemplateCategory from "../TemplateCategory";

describe("TemplateCategory model", () => {
  test("belongsTo relations", () => {
    expect(
      TemplateCategory.belongsTo.map(relation => relation.name)
    ).toMatchSnapshot();
  });

  test("hasMany relations", () => {
    expect(
      TemplateCategory.hasMany.map(relation => relation.name)
    ).toMatchSnapshot();
  });
});
